// Тексты «Поделиться»: кнопка в шапке, строка под подвалом и окно со ссылкой и соцсетями (share/*). На «ты», без рода.

const NB = ' ';

export const SH = {
  button: 'Поделиться',

  // строка в профиле
  profileTitle: 'Пригласить друзей',
  profileSub: 'Своя ссылка — отправь в любой мессенджер или соцсеть',

  // строка под подвалом — слова владельца; доля — с прибыли по роликам друзей, не с оплаты (правила партнёрки, п. 3.1)
  bandTitle: (rate: string) => `Поделись и заработай — ${rate} нашей прибыли с${NB}роликов друзей`,
  bandSub: 'Друзья снимают ролики по твоей ссылке, а доля приходит тебе — с каждого их ролика, бессрочно.',
  bandGuest: 'Получить ссылку',
  bandShare: 'Поделиться',
  bandCopy: 'Скопировать ссылку',
  rate: (rate: number, max: number) => (rate === max ? `${rate}%` : `до${NB}${max}%`),

  // окно
  title: 'Поделиться',
  titleTrend: 'Поделиться трендом',
  titleVideo: 'Поделиться роликом',
  yourLink: 'Твоя ссылка',
  link: 'Ссылка',
  copy: 'Скопировать',
  copied: 'Ссылка скопирована',
  copyFailed: 'Не получилось скопировать — выдели ссылку и скопируй вручную.',
  guestCta: 'Войти, чтобы ссылка была твоей',
  sendTo: 'Куда отправить',
  targets: {
    tg: 'Telegram',
    wa: 'WhatsApp',
    vk: 'ВКонтакте',
    ok: 'Одноклассники',
    viber: 'Viber',
    mail: 'Почта',
    sms: 'SMS',
    more: 'Ещё',
    copy: 'Ссылка',
  },

  // ролик и тренд
  videoSub: 'Отправь сам ролик — в соцсети, историю или друзьям',
  videoSend: 'Отправить ролик',
  trendSub: 'Друг откроет тренд и снимет со своим лицом',

  // что уходит в соцсети: заголовок превью и подпись к ссылке
  msgTitle: 'Весело — ИИ-видео с твоим лицом',
  msg: (gift: number) =>
    `Снимаю себя в вирусных трендах 🎬 Загружаешь селфи — и ты в главной роли.${gift > 0 ? ` По моей ссылке +${gift}% к первому пополнению.` : ''}`,
  msgTrend: (title: string) => `Снимись в тренде «${title}» со своим лицом 🎬`,
  msgVideo: (title: string) => `Мой дубль «${title}» 🎬 Сними свой:`,
};
